import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { BottomNav } from "@/components/BottomNav";

// Paths that should not render the sticky bottom nav.
const PUBLIC_LEGAL_PATHS = new Set([
  "/privacy",
  "/terms",
  "/delete-account",
  "/ai-notice",
  "/privacy-policy",
  "/terms-of-use",
  "/delete-data",
]);

function shouldHideNav(pathname) {
  if (pathname === "/") return true;
  if (pathname === "/onboarding") return true;
  if (pathname === "/premium") return true;
  if (pathname.startsWith("/legal")) return true;
  if (PUBLIC_LEGAL_PATHS.has(pathname)) return true;
  return false;
}

export function AppLayout() {
  const { pathname } = useLocation();
  const hideNav = shouldHideNav(pathname);

  return (
    <div className="relative min-h-[100dvh]" data-testid="app-layout">
      <Toaster
        position="top-center"
        theme="dark"
        toastOptions={{
          style: {
            background: "rgba(15,23,42,0.95)",
            border: "1px solid rgba(255,255,255,0.08)",
            color: "#F8FAFC",
          },
        }}
      />
      <Outlet context={{ hideNav }} />
      {!hideNav && <BottomNav />}
    </div>
  );
}
